import { Vue } from 'vue-property-decorator';
import loader from '../../../utils/loader';
import tableMixin from '../../../Mixins/table';

export default Vue.extend({
  mixins: [tableMixin],
  components: {
    UploadEmployee: loader.component('UploadEmployee'),
  },
  props: {
    corporate: {
      type: Object,
      required: true,
    },
    employees: {
      type: Array,
      default: () => [],
    },
    loadingEmployee: {
      type: Boolean,
      default: false,
    },
    totalPages: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      filter: {
        page: 1,
        itemsPerPage: 10,
        search: null,
      },
      selectedEmployeeEmail: {},
      isDeleteModel: false,
      selectedRadio: 1,
      deleteReason: '',
      RadioOptions: [
        { text: 'Mistyped', value: 'Mistyped' },
        { text: 'Resignation', value: 'Resignation' },
        { text: 'Retirement', value: 'Retirement' },
        { text: 'Other', value: 'Other' },
      ],
      employeeHeader: [
        { text: 'User Id', align: 'center', value: 'user_id', sortable: true },
        { text: 'Email', align: 'center', value: 'email', sortable: true },
        { text: 'Category 1', align: 'center', value: 'category1', sortable: true },
        { text: 'Category 2', align: 'center', value: 'category2', sortable: true },
        { text: 'Category 3', align: 'center', value: 'category3', sortable: true },
        { text: 'Category 4', align: 'center', value: 'category4', sortable: true },
        { text: 'Quota', align: 'center', value: 'quota', sortable: true },
        { text: 'Quota Per Head', align: 'center', value: 'quota_per_head', sortable: false },
        { text: 'Refresh Quota', align: 'center', value: 'refresh_quota', sortable: false },
        { text: 'Active', align: 'center', value: 'active', sortable: true },
        { text: 'Created At', align: 'center', value: 'created_at', sortable: true },
        { text: 'Action', align: 'center', value: 'action', sortable: false },
      ],
    };
  },
  watch: {
    filter: {
      handler(newFilter) {
        this.$emit('filter-change', { ...newFilter });
      },
      deep: true,
    },
  },
  methods: {
    openDeleteEmployeeModal(employee) {
      this.selectedEmployeeEmail = employee;
      this.isDeleteModel = true;
    },
    closeDeleteEmployee() {
      this.isDeleteModel = false;
      this.selectedEmployeeEmail = {};
      this.selectedRadio = 1;
      this.deleteReason = '';
    },
    confirmDelete() {
      const employee = this.selectedEmployeeEmail;
      let reason = '';
      if (this.selectedRadio === '') {
        return; // No reason picked, do nothing
      } else if (this.selectedRadio === 'Other') {
        if (this.deleteReason === '') {
          return; // Other selected but no free-text reason, do nothing
        }
        reason = this.deleteReason;
      } else {
        reason = this.selectedRadio;
      }
      this.$emit('delete-employee', { employee, reason });
      this.closeDeleteEmployee();
    },
  },
});
